import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { User, Mail } from 'lucide-react';

const Profile = () => {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate('/login');
    }
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <div className="py-20 text-center">
        <p className="text-muted-foreground">Carregando...</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div data-testid="profile-page" className="py-20 md:py-32">
      <div className="px-6 md:px-12 lg:px-24 max-w-2xl mx-auto">
        <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight mb-16 text-center">
          Meu Perfil
        </h1>

        <div className="border border-border p-8 md:p-12 space-y-8">
          <div className="flex items-center gap-4 pb-8 border-b border-border">
            <div className="w-16 h-16 bg-primary text-white flex items-center justify-center">
              <User className="w-8 h-8" strokeWidth={1.5} />
            </div>
            <div>
              <p className="font-accent text-xs uppercase tracking-widest text-muted-foreground mb-1">
                Nome
              </p>
              <p data-testid="user-name" className="text-lg font-normal">{user.name}</p>
            </div>
          </div>

          <div className="flex items-center gap-4 pb-8 border-b border-border">
            <div className="w-16 h-16 bg-secondary text-primary flex items-center justify-center">
              <Mail className="w-8 h-8" strokeWidth={1.5} />
            </div>
            <div>
              <p className="font-accent text-xs uppercase tracking-widest text-muted-foreground mb-1">
                E-mail
              </p>
              <p data-testid="user-email" className="text-lg font-normal">{user.email}</p>
            </div>
          </div>

          {user.is_admin && (
            <div className="p-6 bg-accent/10">
              <p className="font-accent text-xs uppercase tracking-widest text-center">
                Conta Administrador
              </p>
            </div>
          )}

          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="w-full bg-transparent border border-primary text-primary px-8 py-4 uppercase tracking-widest text-xs hover:bg-primary hover:text-white transition-all duration-500"
          >
            Sair da Conta
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;